export default [
    {
        path: 'termos-uso/',
        component: require('./Read').default,
        meta: { middleware: 'auth', controller: 'TermosUsoController' }
    }
];